export default "__VITE_ASSET__CkCEr4hc__"